import { createSelector } from 'reselect';
import _ from 'lodash';

const customAppsSelector = createSelector(
  state => state.customApps,
  customApps => _.get(customApps, 'customApps.response.items', []),
);

export { customAppsSelector };
